import {
  call, curry, keys, lensProp, reduce, set,
} from 'ramda';

export default curry((translator, object) => {
  const objectKeys = keys(object);

  return reduce(
    (accum, key) => {
      const value = object[key];
      const newKey = call(translator, key);
      const newKeyLense = lensProp(newKey);

      return set(newKeyLense, value, accum);
    },
    {},
    objectKeys,
  );
});
